module.exports = __webpack_public_path__ + "img/5138493.7fd12137.jpg";